import { toast } from '@/helpers/toast/toast.helper'
import axios from 'axios'
import { put } from 'redux-saga/effects'
import { customButtonCallAction } from '../../handles/customButtonCallAction'
import { t } from 'i18next'

export function* customButtonCallSaga(action: ReturnType<typeof customButtonCallAction.request>) {
  try {
    const { currentChat, customButtonUrl } = action.payload
    yield axios.post(customButtonUrl, { ...currentChat, phone: currentChat.requesterNumber })
    yield put(customButtonCallAction.success())
    toast({ type: 'success', message: t('translation:customButtonCallSaga.successCall') })
  } catch (error) {
    toast({ type: 'error', message: t('translation:customButtonCallSaga.errorCall') })
    yield put(customButtonCallAction.failure())
  }
}
